import React, { ReactNode } from 'react'

interface IButtonBoxProps {
  children: ReactNode
}

export const ButtonBox = (props: IButtonBoxProps) => {
  return <div className="ly__btn-box">{props.children}</div>
}
